import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DiscountsAppliedDto } from '../../models/tuitionCalculation/discountsAppliedDto';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-discount-modal',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './discount-modal.component.html',
  styleUrl: './discount-modal.component.css'
})
export class DiscountModalComponent {

  @Input() disc!: DiscountsAppliedDto;

  constructor(private sharedService: SharedService) {

  }

  ngOnInit(): void {
    console.log('Se ha recibido un listado de descuentos: ', this.disc);
    this.sharedService.showDiscountModal();
  }

  hideDiscountModal() {
    const modalEl = document.getElementById('discount-modal') as HTMLElement;
    if (modalEl) {
      modalEl.classList.remove('show');
      modalEl.style.display = 'none';
      document.body.classList.remove('modal-open');

      // eliminar backdrop si existe
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      // Avisamos para cerrar el evento del modal para el listado de los descuentos
      this.sharedService.setInitSelectDiscountModal(false);
    }
  }


}
